<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <Watermark :info="showText"></Watermark>
  </div>
</template>

<script>
import utils from '@/common/utils.js'
import Watermark from '@/components/Watermark.vue'
export default {
  components: { Watermark },
  name: 'App',
  data:()=>{
    return {
      showText:'默认水印'
    }
  },
  created() {
    // 获取会话缓存
    const debug = !true //是否调试模式，为true时会打印相关的请求参数，且请求地址和token等权限都是本地的
    const LOCK = "test"
    const paramObj = {
      'dev': {
        platformType: '1', //环境：
        enterprise: '4'
      },
      'test': {
        platformType: '1',
        enterprise: '4'
      },
      'preRelease': {
        platformType: '1',
        enterprise: '4'
      },
      'prod': {
        platformType: '1',
        enterprise: '4'
      },
    }
    const urlObj = {
      'dev': 'https://partnerapi.enjlink.cn/partnerapi',
      'test': 'https://partnerapi.enjlink.cn/partnerapi',
      'preRelease': 'https://inchargeloangateway.enjlink.com/partnerapi',
      'prod': 'https://inchargeloangateway.enjlink.com/partnerapi',
    }
    const allParam = getAllParam()
    const data = allParam.data ? JSON.parse(decodeURIComponent(allParam.data)) : {}
    const position = allParam.position ? JSON.parse(decodeURIComponent(allParam.position)) : {}
    const powerObj = allParam.powerObj ? JSON.parse(decodeURIComponent(allParam.powerObj)) : {}
    if (debug) {
      console.log('url获取所有跳转H5参数：allParam', allParam)
      console.log('获取所有页面数据：data', data)
      console.log('位置数据：position', position)
    }
    if(allParam.userName && allParam.userMobile){
      this.showText = allParam.userName + ' ' + allParam.userMobile.slice(-4)
    }
    // 全局数据
    // const powDataToken = ['1569894616830967808', '1561691589619875840', '1586908289545928704', '1632781015795761152', '1601495282749669376', '1626188411490664448'] //第一项为合伙人权限
    const globalData = {
      apiQue: {},
      LOCK:LOCK,
      apiPath: urlObj[LOCK], //请求地址
      token: allParam.token, //'3XwoCriQTztzt6ifHhIxMbF8r2m7sySEzxdPv9YOc2w2AUKrs2nUEM79rXH3moeM'||
      role: allParam.role,//角色==0.企业负责人（代理） 1.员工BD 2.商户（老板/店长） 3.店员 4.普通用户 5.渠道商 6.仓管 7.财务 10.BDM 11.CM
      enterpriseRole: allParam.enterpriseRole,//角色==0:悦享 1:合伙人 2:代理商 
      enterprise: allParam.enterprise, //企业id
      debug,
      entireURLs: '',
      location: position,
      enterpriseParam: paramObj[LOCK],
      powerObj:powerObj
    }
    window.globalData = globalData
    // 获取所有参数
    function getAllParam() {
      const paramsString = window.location.search.substring(1);
      if (paramsString) {
        const paramsArray = paramsString.split('&');
        const paramsObj = {};
        paramsArray.forEach(param => {
          const [key, value] = param.split('=');
          paramsObj[key] = decodeURIComponent(value.replace(/\+/g, ' '));
        })
        return paramsObj
      } else {
        return {}
      }

    }

    function isWechat() {
      //获取user-agaent标识头
      var ua = window.navigator.userAgent.toLowerCase();
      //判断ua和微信浏览器的标识头是否匹配
      if (ua.match(/micromessenger/i) == 'micromessenger') {
        return true;
      } else {
        return false;
      }
    }
  },
}
</script>

<style>
@import './style/font/din.css';
* {
  margin: 0;
  padding: 0;
}


a {
  color: #191919;
}

html {
  font-size: calc(100vw / 7.5);
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100vw;
  height: calc(100vh - env(safe-area-inset-bottom) - env(safe-area-inset-top));
  overflow: auto;
  position: absolute;
  padding: 0;
  font-size: 0.28rem;
}

.nav-main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 10px;
}

.van-nav-bar__left .van-icon {
  color: #636363 !important;
}

.van-nav-bar__left .van-nav-bar__arrow {
  font-size: 20px !important;
}

.van-nav-bar__title {
  /* font-size: 15px;
  color: #666; */
  font-size: 0.34rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #202620;
}

/* toast的默认样式 */
.van-toast.van-newToast {
  font-size: .28rem;
  font-weight: 500;
  color: #FFFFFF;
  line-height: .44rem;
  /* background: rgba(0, 0, 0, 0.9); */
  /* box-shadow: 0 .12rem .32rem 0 rgba(0, 0, 0, 0.1); */
  background: #4c4c4c;
  border-radius: .16rem;
}

.van-toast--text.van-newToast {
  padding: .24rem .52rem;
}

/* dialog的默认样式 */
.van-dialog.van-newDialog {
  width: 6.4rem;
  border-radius: .16rem;
}

.van-newDialog .van-dialog__header {
  padding-top: .62rem;
  font-size: .34rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.9);
}

.van-newDialog .van-dialog__message {
  padding: .24rem .48rem .56rem;
  line-height: .48rem;
  color: rgba(0, 0, 0, 0.65);
  font-size: .32rem;
}

.van-newDialog .van-dialog__message--has-title {
  color: rgba(0, 0, 0, 0.65);
  padding-top: .24rem;
}

.van-newDialog .van-dialog__cancel,
.van-newDialog .van-dialog__confirm {
  height: 1.14rem;
}

.van-newDialog .van-button__text {
  font-size: .34rem;
  font-weight: 600;
}

.van-newDialog .van-dialog__cancel .van-button__text {
  font-weight: 400;
}
.van-toast.van-newToast.rotateToast-gg{
  transform:translate(-50%,-50%) rotate(-90deg);
}
.confirm-style{
  color: #34BF00;
}
</style>



// WEBPACK FOOTER //
// src/App.vue